import React from "react";
import LondonBanner from "./components/LondonBanner";
import EngWedRing from "./components/EngWedRing";
import BestSeller from "./components/BestSeller";
import WhyBuy from "./components/WhyBuy";
import VideoBanner from "./components/VideoBanner";
import LearnDiamond from "./components/LearnDiamond";
import WhatPeopleSay from "./components/WhatPeopleSay";
import InstaLondon from "./components/InstaLondon";
import NewsLetter from "./components/NewsLetter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import { Theme } from "../../../../Helpers/request";

// if(Theme === 'london'){
// require(`./assets/css/london.css`);
// }

function LondonHome() {
  return (
    <div className='LondonThemHome'>
      <LondonBanner />
      <BestSeller />
      <EngWedRing />
      <WhyBuy/>
      <VideoBanner/>
      <LearnDiamond/>
      <WhatPeopleSay/>
      <InstaLondon />
      <NewsLetter />
    </div>
  );
}

export default LondonHome;
